import React from "react";
import { observer } from "mobx-react";
import SubscriptionIndexPage from "~/modules/BillingCentral/app/SubscriptionIndexPage";
import "../styles/SidePage.less";

const ClientPanelSubscriptionIndexPage = observer(props => <SubscriptionIndexPage {...props} />);

export default ClientPanelSubscriptionIndexPage;
